import PropTypes from 'prop-types';
import './Loader.scss';

const Loader = ({className = ''}) => (
  <div className={`loader ${className}`} data-cy="loader">
    <div className="loader__inner">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

const { string } = PropTypes;

Loader.propTypes = {
  className: string,
};
export default Loader;
